import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import style from '../NotificationDrawer.module.scss';
export const NotificationSkeletonLoader = () => {
    const loaderArray = [...Array(25)];
    const loaderCount = 0;
    return (_jsx("div", { className: `${style['skeleton-loader']} mt-4`, "data-testid": "skeleton-loader", children: loaderArray?.map((_value, index) => {
            return (_jsxs("div", { "data-testid": "notification-skeleton", children: [_jsx(CatSkeleton, { className: "cat-u-display-block cat-u-margin-bottom-sm", size: "sm", width: "40%" }), _jsx(CatSkeleton, { className: "cat-u-display-block cat-u-margin-bottom-sm", size: "sm", width: "40%" }), _jsx(CatSkeleton, { className: "cat-u-display-block cat-u-margin-bottom-sm", size: "sm", slot: "footer" })] }, `${loaderCount + index}`));
        }) }));
};
